module.exports = __webpack_public_path__ + "img/hokkaido_soup_ingredients.c8183a04.jpg";